<template>
  <div class="col-md-12">
    <div class="card card-container">
      <img id="profile-img" src="../assets/ggpoker.png" />
      <Form
        v-if="!message"
        @submit="handleSendMoney"
        :validation-schema="schema"
      >
        <div>
          <div class="ui container">
            <video
              v-if="!imageData.image"
              ref="video"
              class="camera-stream"
              autoPlay="true"
              playsInline="true"
              muted="true"></video>
          </div>
          <div v-if="imageData.image">
            <img
              class="videoImage"
              :src="imageData.image"
              :style="`rotate:${imageData.image_orientation}deg`"
            />
          </div>
          <div class="ui divider">
            <div class="icon-group">
              <div class="camera-icon" @click="captureImage()">
                <i class="big camera icon"></i>
                <p>Take Picture</p>
              </div>
              <div class="camera-icon" @click="rotateImage()">
                <i class="big redo alternate icon"></i>
                <p>Rotate</p>
              </div>
              <div class="camera-icon" @click="doneImage()">
                <i class="big thumbs up outline icon"></i>
                <p>Done</p>
              </div>
              <div class="camera-icon" @click="cancelImage()">
                <i class="big cancel icon"></i>
                <p>Cancel</p>
              </div>
            </div>
          </div>
        </div>
      </Form>

      <div
        v-if="message"
        class="alert"
        :class="successful ? 'alert-success' : 'alert-danger'"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>
  
  <script>
import { Form } from "vee-validate";
import * as yup from "yup";
import transactionService from "../services/transaction.service";

export default {
  name: "Proof",
  components: {
    Form,
  },
  data() {
    const schema = yup.object().shape({
      username: yup
        .string()
        .required("Username is required!")
        .min(3, "Must be at least 3 characters!")
        .max(20, "Must be maximum 20 characters!"),
      email: yup
        .string()
        .required("Email is required!")
        .email("Email is invalid!")
        .max(50, "Must be maximum 50 characters!"),
      password: yup
        .string()
        .required("Password is required!")
        .min(6, "Must be at least 6 characters!")
        .max(40, "Must be maximum 40 characters!"),
    });

    return {
      mediaStream: null,
      imageData: {
        image: "",
        image_orientation: 0,
      },

      successful: false,
      loading: false,
      message: "",
      schema,
      fields: {
        cpf: "",
        typePix: "",
        chavePix: "",
        value: "",
      },
    };
  },
  computed: {
    loggedIn() {
      return (
        this.$store.state.auth.status.loggedIn &&
        this.$store.state.auth.user.validOTP
      );
    },
  },
  mounted() {
    if (!this.loggedIn) {
      this.$root.logOut();
    }
    if (
      "mediaDevices" in navigator &&
      "getUserMedia" in navigator.mediaDevices
    ) {
      console.log("Let's get this party started");
    }
    navigator.mediaDevices
      .getUserMedia({
        audio: false,
        video: {
          facingMode: "environment",
          width: 400,
          height: 250,
        },
      })
      .then((mediaStream) => {
        this.$refs.video.srcObject = mediaStream;
        this.$refs.video.play();
        this.mediaStream = mediaStream;
      });
  },
  methods: {
    captureImage() {
      // alert("Capturando imagen");
      const mediaStreamTrack = this.mediaStream.getVideoTracks()[0];
      const imageCapture = new window.ImageCapture(mediaStreamTrack);
      let reader = new FileReader();
      return imageCapture.takePhoto().then((blob) => {
        reader.readAsDataURL(blob);
        reader.onload = () => {
          // alert("OnLoad");
          this.imageData.image = reader.result;
          // alert(this.imageData.image);
          // let img = document.createElement('img');
          // img.src = this.imageData.image  ;
          // self.$refs['img-container'].appendChild(img);
        };
      });
    },
    doneImage() {
      console.log("Done Image");
      let d = {
        image: this.imageData.image,
        imageOrientation: this.imageData.image_orientation,
        id: this.$route.params.id,
      };
      // alert("done");
      // alert(this.imageData.image);
      // alert(d);
      transactionService.sendProof(d).then(
        (data) => {
          console.log("SendProof Successfuly");
          console.log(data);
          this.message = data.message;
          this.successful = true;
          this.loading = false;
          this.fields.cpf = "";
          this.fields.typePix = "";
          this.fields.chavePix = "";
          this.fields.value = "";
          setTimeout(() => {
            this.$router.push("/sendMoney");
          }, 3000);
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.successful = false;
          this.loading = false;
        }
      );
    },
    rotateImage() {
      console.log("Rotate Image");
      console.log(this.imageData);
      this.imageData.image_orientation = this.imageData.image_orientation + 90;
    },
    cancelImage() {
      this.imageData.image = null;
      this.showCameraModal = true;
      navigator.mediaDevices
        .getUserMedia({
          video: {
            facingMode: "environment",
            width: 400,
            height: 250,
          },
        })
        .then((mediaStream) => {
          this.$refs.video.srcObject = mediaStream;
          this.$refs.video.play();
          this.mediaStream = mediaStream;
        });
    },

    handleSendMoney(data) {
      this.message = "";
      this.successful = false;
      this.loading = true;

      this.$store.dispatch("transaction/sendMoney", data).then(
        (data) => {
          this.message = data.message;
          this.successful = true;
          this.loading = false;
          this.fields.cpf = "";
          this.fields.typePix = "";
          this.fields.chavePix = "";
          this.fields.value = "";
          setTimeout(() => {
            this.message = "";
            this.successful = false;
            this.loading = false;
          }, 3000);
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.successful = false;
          this.loading = false;
        }
      );
    },
  },
};
</script>
  
  <style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}
.videoImage {
  height: 400px !important;
  width: 250px !important;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.error-feedback {
  color: red;
}
</style>
  